window.onload = function() {
  var par_elem = document.getElementById("expressrex-bundle-layout");
  var elem = par_elem.childNodes[0].childNodes[0].childNodes[0].childNodes[0];
  var markup = elem.innerHTML;

 // var exp = new RegExp('&lt;', 'g');
 // var exp2 = new RegExp('&gt;', 'g');
 // markup.replace(exp, "<");
 // markup.replace(exp2, ">");

  var cleanstring = markup;

  cleanstring = cleanstring.replace("&amp;lt;sup&amp;gt;", "");
  cleanstring = cleanstring.replace("&amp;lt;/sup&amp;gt;", "");
  cleanstring = cleanstring.replace("&lt;sup&gt;", "");
  cleanstring = cleanstring.replace("&lt;/sup&gt;", "");
  cleanstring = cleanstring.replace("<sup>", "");
  cleanstring = cleanstring.replace("</sup>", "");
  
  
  
  cleanstring = cleanstring.replace(":", "!");

 // cleanstring = "<a href=\"#\" id=\"expressrex-bundle-buy-link\">" + cleanstring + "</a>";
 
  elem.innerHTML = cleanstring;
  
  show_mats();
  
}

function show_mats() {
	var elem = document.getElementById("collapseOne");
   	var bundle_elem = document.getElementById("prodbundle");
  	if (elem.innerHTML.indexOf("MATERIALS REQUIRED") > -1
       || elem.innerHTML.indexOf("REQUIRED BOOKS") > -1 ) {
      bundle_elem.style.display = 'block';
    } else {
      bundle_elem.style.display = 'none';
    }
}

